import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import * as d3 from "d3";
import { SchoolEvent } from '../../../calendar/models/school-event';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { Student } from 'src/app/models/student';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { PersonType } from 'src/app/models/person';
import { AlertPopupService } from 'alert-popup';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { OnlineMeetingsService } from '../../../online-meetings/services/online-meetings.service';
declare var platform;

@Component({
  selector: 'app-time-table',
  templateUrl: './time-table.component.html',
  styleUrls: ['./time-table.component.scss']
})
export class TimeTableComponent extends ComponentBase implements OnInit {

  constructor(private routingService: RoutingService, 
    private settingsService: SettingsService
    , private alertService: AlertPopupService
    , private onlineMeetingService: OnlineMeetingsService) {
      super();
     }

  @Input() timeTable: Array<SchoolEvent>
  @Input() exams: Array<SchoolEvent>
  @ViewChild('timetableDiv', { static: true }) divTimetable: ElementRef
  intervalId;
  @Input() selectedProfile: Student;
  @Input() personType: PersonType;

  ngOnInit() {
    setTimeout(() => {
      d3.select(this.divTimetable.nativeElement).select("svg").attr("width", this.divTimetable.nativeElement.clientWidth);
    }, 1);

  }

  ngOnChanges() {
    this.drawTimetable(this.divTimetable.nativeElement.offsetWidth);
  }

  drawTimetable(width) {
    d3.select(this.divTimetable.nativeElement).selectAll("svg").remove();
    var formatDateTime = d3.timeParse("%Y-%m-%dT%H:%M:%S");
    var formatTime = d3.timeFormat("%I:%M %p");
    var currentDateTime = new Date();

    var minDateTime: any;
    var maxDateTime: any;
    
    if (this.timeTable.length && this.exams.length) {
      var minTimeTable = d3.min(this.timeTable, (d: any) =>
        formatDateTime(d.start_date)
      );
      var minExam = d3.min(this.exams, (d: any) =>
        formatDateTime(d.start_date)
      );

      minDateTime = d3.min([minTimeTable,minExam]);

      var maxTimeTable = d3.max(this.timeTable, (d: any) =>
        formatDateTime(d.end_date)
      );
      var maxExam = d3.max(this.exams, (d: any) =>
        formatDateTime(d.end_date)
      );

      maxDateTime = d3.max([maxTimeTable,maxExam]);

      if((maxDateTime.getHours() - minDateTime.getHours())< 5){
        maxDateTime.setHours(minDateTime.getHours() + 8);
      }

    }
    else if (this.timeTable.length) {
      minDateTime = d3.min(this.timeTable, (d: any) =>
        formatDateTime(d.start_date)
      );
      if(this.timeTable.length <= 3){
        var endDate = new Date(this.timeTable[0].start_date);
        endDate.setHours(endDate.getHours() + 7);
        maxDateTime = endDate;
      }
      else{
        maxDateTime = d3.max(this.timeTable, (d: any) => 
          formatDateTime(d.end_date)
        );
      } 
    }
    else {
      minDateTime = d3.min(this.exams, (d: any) =>
        formatDateTime(d.start_date)
      );
      var endDate = new Date(this.exams[0].start_date);
      endDate.setHours(endDate.getHours() + 10);
      maxDateTime = endDate;
    }


    var x = d3.scaleTime().range([0, 1500])
      .domain([minDateTime, maxDateTime]);

    var x_axis = d3.axisBottom(x);

    var timeline_x = x;
    let zoomFunction = function () {
      var new_xScale = d3.event.transform.rescaleX(x);
      xAxis.call(d3.axisBottom(new_xScale));
      rectTimetable.attr("x", function (d) {
        return new_xScale(formatDateTime(d.start_date));
      })
        .attr("width", function (d) {
          return new_xScale(formatDateTime(d.end_date)) - new_xScale(formatDateTime(d.start_date));
        });
      foreignObjectTimetable.attr("x", function (d) {
        return new_xScale(formatDateTime(d.start_date));
      });
      rectExams.attr("x", function (d) {
        return new_xScale(formatDateTime(d.start_date));
      })
        .attr("width", function (d) {
          return new_xScale(formatDateTime(d.end_date)) - new_xScale(formatDateTime(d.start_date));
        });
      foreignObjectExam.attr("x", function (d) {
        return new_xScale(formatDateTime(d.start_date));
      });
      circleHW.attr("cx", function (d) {
        return new_xScale(formatDateTime(d.end_date)) - 20;
      });
      
      textHW.attr("x", (d: any) =>
        new_xScale(formatDateTime(d.end_date)) - 20
      );
      if (currentDateTime > minDateTime && currentDateTime < maxDateTime) {
        timeline_x = new_xScale;
        timelineCircle.attr("cx", function() {
          return new_xScale(currentDateTime);
        });
        timeline.attr("x1", function () {
          return new_xScale(currentDateTime);
        })
          .attr("x2", function () {
            return new_xScale(currentDateTime);
          });
        timelinetext.attr("x", function () {
          return new_xScale(currentDateTime) + 3;
        });
      }  
    }

    var zoom = d3.zoom()
      .translateExtent([[-100, 0], [x(maxDateTime) + 100, 0]])
      .on("zoom", zoomFunction);

    let svgContainer: any = d3.select(this.divTimetable.nativeElement).append("svg")
      .attr("height", 160)
      .attr("width", width)
      .call(zoom)
      .on("wheel.zoom", null)
      .on("dblclick.zoom", null);

    if (this.timeTable.length) {
      var groupTimetable = svgContainer.append("g")
        .selectAll("g")
        .data(this.timeTable)
        .enter()
        .append("g");
    }
    else {
      var groupTimetable = svgContainer.append("g")
        .selectAll("g")
        .data(this.exams)
        .enter()
        .append("g");
    }

    
    var rectTimetable = groupTimetable.append("rect")
      .attr("x", (d: any) =>
        x(formatDateTime(d.start_date))
      )
      .attr("y", 40)
      .attr("width", (d: any) =>
        x(formatDateTime(d.end_date)) - x(formatDateTime(d.start_date))
      )
      .attr("height", 120)
      .attr("class", "rectTimetable")
      .attr("rx", "5")
      .attr("ry", "5");

    var foreignObjectTimetable = groupTimetable.append("foreignObject")
      .attr("x", (d: any) =>
        x(formatDateTime(d.start_date))
      )
      .attr("y", 40)
      .attr("width", (d: any) =>
        x(formatDateTime(d.end_date)) - x(formatDateTime(d.start_date))
      )
      .attr("height", 120);

    var timetableDetailsDiv = foreignObjectTimetable.append('xhtml:div')
      .attr("class", "subject-detail");

    timetableDetailsDiv.append('div')
      .attr("class", "timetable-subject")
      .attr("title", (d: any) => d.title)
      .html((d: any) => d.title); 

    timetableDetailsDiv.append('div')
      .attr("class", "timetable-time")
      .attr("title", (d: any) => formatTime(formatDateTime(d.start_date)) + " to " + formatTime(formatDateTime(d.end_date)))
      .html((d: any) => formatTime(formatDateTime(d.start_date)) + " to " + formatTime(formatDateTime(d.end_date)));

    this.settingsService.getSettings().subscribe(res => {
      if (res.is_online_class_enabled) {
        var timetableJoinButton = timetableDetailsDiv.append('a')
          .attr("class", "timetable-join-link")
          .html("<i class='fas fa-play-circle'></i> Join now")
          .style("visibility", (d: any) => {
            var start = formatDateTime(d.start_date).getTime() - res.online_class_start_time_buffer_mins * 60000;
            var end = formatDateTime(d.end_date).getTime() + res.online_class_end_time_buffer_mins * 60000;
            var dt = currentDateTime;
            return (dt.getTime() >= start && dt.getTime() <= end) ? "visible" : "hidden"
          });

        timetableJoinButton.on("click", (d: any) => {
          this.onlineMeetingService.getJoinUrlForEvent(d.occurrence_id).subscribe((res) => {
            window.open(res['join_url'], "_blank");
          }, err => {
            if (err.code == "MEETING_NOT_FOUND"){
              let route = new PrifactRoute();
              route.primary_command = ['online-meeting-lobby'];
              route.query_params = { 
                "eventId": d.occurrence_id
              };
              route.append_current_url_to_history = true;
              this.routingService.navigate(route);
            }
            else{
              this.alertService.newAlert(err.error.message);
            }
          });
        })
        
      }
    });

    if (this.timeTable.length) {
      var groupHW = svgContainer.append("g")
        .selectAll("g")
        .data(this.timeTable)
        .enter()
        .append("g")
        .filter((d: any) => d.hasHomeWork);
    }
    else {
      var groupHW = svgContainer.append("g")
        .selectAll("g")
        .data(this.exams)
        .enter()
        .append("g")
        .filter((d: any) => d.hasHomeWork);
    }

    var circleHW = groupHW.append("circle")
      .filter((d: any) => d.hasHomeWork)
      .attr("cx", (d: any) => x(formatDateTime(d.end_date)) - 20)
      .attr("cy", 60)
      .attr("r", 10)
      .attr("class", "circleHomework")
      .attr("fill", "#00bcca");

    var textHW = groupHW.append("text")
      .attr("fill", "white")
      .style("text-anchor", "middle")
      .style("alignment-baseline", "middle")
      .attr("font-size", "10px")
      .attr("class", "textHomework")
      .text("H")
      .attr("x", (d: any) =>
        x(formatDateTime(d.end_date)) - 20
      )
      .attr("y", 60);

    var groupExams = svgContainer.append("g")
      .selectAll("g")
      .data(this.exams)
      .enter()
      .append("g");

    var rectExams = groupExams.append("rect")
      .attr("x", (d: any) =>
        x(formatDateTime(d.start_date))
      )
      .attr("y", 40)
      .attr("width", (d: any) =>
        x(formatDateTime(d.end_date)) - x(formatDateTime(d.start_date))
      )
      .attr("height", 120)
      .attr("class", "rectExams")
      .attr("rx", "5")
      .attr("ry", "5");

    var foreignObjectExam = groupExams.append("foreignObject")
      .attr("x", (d: any) =>
        x(formatDateTime(d.start_date))
      )
      .attr("y", 40)
      .attr("width", (d: any) =>
        x(formatDateTime(d.end_date)) - x(formatDateTime(d.start_date))
      )
      .attr("height", 120);

    var examDetailsDiv = foreignObjectExam.append('xhtml:div')
      .attr("class", "subject-detail");

    examDetailsDiv.append('div')
      .attr("class", "timetable-subject")
      .attr("title", (d: any) => d.title)
      .html((d: any) => d.title);

    examDetailsDiv.append('div')
      .attr("class", "timetable-time")
      .attr("title", (d: any) => formatTime(formatDateTime(d.start_date)) + " to " + formatTime(formatDateTime(d.end_date)))
      .html((d: any) => formatTime(formatDateTime(d.start_date)) + " to " + formatTime(formatDateTime(d.end_date)));

    var timelineCircle;
    var timelinetext;
    var timeline;
    var groupTimeline;
    let dateTimeFunction = function() {
      currentDateTime = new Date();
      if (currentDateTime > minDateTime && currentDateTime < maxDateTime) {
        d3.selectAll(".timeline-group").remove();
        groupTimeline = svgContainer.append("g").attr("class", "timeline-group");
        timelineCircle = groupTimeline.append("circle")
          .attr("class", "timeline-circle")
          .attr("cx",timeline_x(currentDateTime))
          .attr("cy",3)
          .attr("r",3)
          .style("fill", "red");
        timelinetext = groupTimeline.append("text")
          .attr("class", "timeline-time")
          .style("fill", "black")
          .attr("x", timeline_x(currentDateTime) + 3)
          .attr("y", 35)
          .text(formatTime(currentDateTime))
        timeline = groupTimeline.append("line")
          .style("stroke", "red")
          .style("stroke-width", 1)
          .attr("x1", timeline_x(currentDateTime))
          .attr("y1", 5)
          .attr("x2", timeline_x(currentDateTime))
          .attr("y2", 160);
      }
    }
    dateTimeFunction();
   
    this.intervalId = setInterval(dateTimeFunction,30000);
    
    var xAxis = svgContainer.append("g")
      .attr("class", "xAxis")
      .call(x_axis);

    let clickedPan = function () {
      if (width < x(maxDateTime)) {
        var currentPos = svgContainer._groups[0][0].__zoom;
        var direction = this.getAttribute("data-pan") * -1;
        let nextPos = currentPos.x + 100 * direction;
        if (nextPos <= 100 && nextPos >= (x(maxDateTime) - width + 100) * -1) {
          svgContainer.transition()
            .duration(500)
            .call(zoom.transform, d3.zoomIdentity.translate(nextPos, 0))
        }
      }
    }

    d3.selectAll("button[data-pan]")
      .on("click", clickedPan);
  }

  resizeSvg() {
    d3.select(this.divTimetable.nativeElement).select("svg").attr("width", this.divTimetable.nativeElement.clientWidth);
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

}
